<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/AlertPM'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body pt-2">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
              v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <label>Agent:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMAgentCode'"
                    :name="'reAPMAgentCode'"
                    :select2-options="reAPMAgentCodeOptions"
                    v-model="reAPMAgentCode"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reAPMAgentCode"
                    :multiple="true"
                    :options="reAPMAgentCodeOptions"
                    v-on:open="LoadreAPMAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

               <!-------ตัวแทนจำหน่ายย่อย---->
               <div
                class="col-xl-6 col-lg-6 col-md-6 col-xs-6"
                v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'" 
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    ref="pmrSubAgentCodesSelect2"
                    multiple
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <label>Region:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMRegion'"
                    :name="'reAPMRegion'"
                    :select2-options="reAPMRegionOptions"
                    multiple
                    v-model="reAPMRegion"
                  ></select2> -->
                  <treeselect
                    v-model="reAPMRegion"
                    :multiple="true"
                    :options="reAPMRegionOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">เดือน(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(ดด/ปปปป)"
                      id="reAPMDateStart"
                      name="reAPMDateStart"
                      ref="reAPMDateStart"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">เดือน(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(ดด/ปปปป)"
                      id="reAPMDateEnd"
                      name="reAPMDateEnd"
                      ref="reAPMDateEnd"
                      autocomplete="off"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" style="display:none">
                <div class="form-group">
                  <label>เลือกครั้ง Alert:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMAlertCount'"
                    :name="'reAPMAlertCount'"
                    :select2-options="reAPMAlertCountOptions"
                    v-model="reAPMAlertCount"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reAPMAlertCount"
                    :multiple="true"
                    :options="reAPMAlertCountOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>นับรอบ Alert ครั้งที่:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMAlertCycle'"
                    :name="'reAPMAlertCycle'"
                    :select2-options="reAPMAlertCycleOptions"
                    v-model="reAPMAlertCycle"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reAPMAlertCycle"
                    :multiple="true"
                    :options="reAPMAlertCycleOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" style="display:none">
                <div class="form-group">
                  <label>Type:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMAlertCount'"
                    :name="'reAPMAlertCount'"
                    :select2-options="reAPMAlertCountOptions"
                    v-model="reAPMAlertCount"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reAPMType"
                    :multiple="true"
                    :options="reAPMTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อผู้ใช้งาน:</label>
                  <treeselect
                    v-model="reAPMCreatedUserId"
                    :multiple="true"
                    :load-options="LoadreAPMCreatedUserIdOptions"
                    :async="true"
                    v-on:open="reLoadreAPMCreatedUserIdOptions"
                    v-on:select="ClearAfterselect"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="true"
                    ref="reAPMCreatedUserId"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMShopId'"
                    :name="'reAPMShopId'"
                    :select2-options="reAPMShopIdOptions"
                    multiple
                    v-model="reAPMShopId"
                  ></select2> -->
                  <treeselect
                    v-model="reAPMShopId"
                    :multiple="true"
                    :load-options="LoadreAPMShopIdOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="ค้นหาจาก ชื่อร้านค้า เช่น ชื่อร้านค้า1,ชื่อร้านค้า2"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>BARCODE (เครื่องทำความเย็น/หัวจ่าย):</label>
                  <input
                    id="reAPMBarcodeNo"
                    name="reAPMBarcodeNo"
                    v-model="reAPMBarcodeNo"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะร้านค้า:</label>
                  <!-- <label>Status:</label> -->
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMStatus'"
                    :name="'reAPMStatus'"
                    :select2-options="reAPMStatusOptions"
                    v-model="reAPMStatus"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" style="display:none">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <label>Brand:</label> -->
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAPMBrand'"
                    :name="'reAPMBrand'"
                    :select2-options="reAPMBrandOptions"
                    multiple
                    v-model="reAPMBrand"
                  ></select2> -->
                  <treeselect
                    v-model="reAPMBrand"
                    :multiple="true"
                    :options="reAPMBrandOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" style="display:none">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect
                    v-model="rePMShopTypeId"
                    :multiple="true"
                    :options="rePMShopTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" style="display:none">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMProvinceId'"
                    :name="'rePMProvinceId'"
                    :select2-options="rePMProvinceIdOptions"
                    @selectChange="onAmpherIdChange"
                    v-model="rePMProvinceId"
                    ref="rePMProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" style="display:none">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'rePMAmpherId'"
                    :name="'rePMAmpherId'"
                    :select2-options="rePMAmpherIdOptions"
                    v-model="rePMAmpherId"
                    ref="rePMAmpherIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" style="display:none">
                <div class="form-group">
                  <label>ประเภท เครื่อง:</label>
                  <treeselect
                    v-model="rePMMachineProductCode"
                    :multiple="true"
                    :options="rePMMachineProductCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทการล้างเครื่อง:</label>
                  <treeselect
                    v-model="shmShopPMType"
                    :multiple="true"
                    :options="shmShopPMTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset($event)"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportAlertPM"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="alertPMTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="17">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย/รหัสตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย/ชื่อตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ประเภทตัวแทนจำหน่าย</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">ชื่อผู้ใช้งาน (Username)</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ประเภทการล้างเครื่อง</th>
                    <th class="all text-center">Type (ครื่องทำความเย็น/หัวจ่าย)</th>
                    <!-- <th class="all text-center">รหัสบาร์โค้ดเครื่อง</th> -->
                    <th class="all text-center">BARCODE (เครื่องทำความเย็น/หัวจ่าย)</th>
                    <th class="all text-center">ประเภท (ครื่องทำความเย็น/หัวจ่าย)</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">วันที่ล้างล่าสุด</th>
                    <th class="all text-center">วันที่ alert ล่าสุด</th>
                    <th class="all text-center">เลือกครั้ง Alert</th>
                    <th class="all text-center">นับรอบ Alert ครั้งที่</th>
                    <!-- <th class="all text-center">สถานะการจับคู่</th> -->
                    <!-- <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">จังหวัด</th>
                    <th class="all text-center">อำเภอ</th> -->

                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      reAPMAgentCode: [],
      reAPMRegion: [],
      reAPMDateStart: null,
      reAPMDateEnd: null,
      reAPMCreatedUserId: [],
      reAPMBarcodeNo: null,
      reAaProductBrand: [],
      reAPMStatus: null,
      reAPMAlertCount: [],
      reAPMAlertCycle: [],
      reAPMBrand: [],
      reAPMShopId: [],
      reAPMShopIdOptions: [],
      reAPMType: [],

      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [],

      shmShopPMType: [],
      shmShopPMTypeOptions : [],

      
      LoadshmShopPMTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Select2MasterShopTypePM", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopPMTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
      }, 

      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.reAPMAgentCode,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },  
      // reAPMShopIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกCustomer Code/Name",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/AlertPM/ShopOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAPMCreatedUserIdOptions: [],
      // reAPMCreatedUserIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกUsername",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/PM/UserNameOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAPMBarcodeOptions: [],
      // reAPMBarcodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสบาร์โค้ดเครื่อง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2Barcode",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAPMAgentCodeOptions: [],
      // reAPMAgentCodeOptions: {
      //   placeholder: "กรุณาเลือกAgent",
      //   allowClear: true,
      //   ajax: {
      //     url:
      //       "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         AgentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      reAPMRegionOptions: [],
      // reAPMRegionOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือก Region",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Agents/Select2SearchDepartment",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      rePM3Options: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
      reAPMStatusOptions: {
        minimumResultsForSearch: -1,
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          {
            id: false,
            text: "ร้านเปิด",
            data: null,
          },
          {
            id: true,
            text: "ร้านปิด",
            data: null,
          },
        ],
      },
      reAPMAlertCountOptions: [
        // {
        //   id: 7,
        //   label: "7",
        // },
        // {
        //   id: 15,
        //   label: "15",
        // },
      ],
      reAPMTypeOptions: [
        {
          id: "บริษัท",
          label: "บริษัท",
        },
        {
          id: "เครื่องเช่า",
          label: "เครื่องเช่า",
        },
        {
          id: "ส่วนบุคคล",
          label: "ส่วนบุคคล",
        },
      ],
      // reAPMAlertCountOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกครั้ง Alert",
      //   allowClear: true,
      //   data: [
      //     {
      //       id: 7,
      //       text: "7",
      //       data: null,
      //     },
      //     {
      //       id: 15,
      //       text: "15",
      //       data: null,
      //     },
      //   ],
      // },
      reAPMAlertCycleOptions: [
        {
          id: 1,
          label: "1",
        },
        {
          id: 2,
          label: "2",
        },
        {
          id: 3,
          label: "3",
        },
        {
          id: 4,
          label: "4",
        },
        {
          id: 5,
          label: "5",
        },
        {
          id: 6,
          label: "มากกว่า 5",
        }
      ],
      // reAPMAlertCycleOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกนับรอบ Alert ครั้งที่",
      //   allowClear: true,
      //   data: [
      //     {
      //       id: 1,
      //       text: "1",
      //       data: null,
      //     },
      //     {
      //       id: 2,
      //       text: "2",
      //       data: null,
      //     },
      //     {
      //       id: 3,
      //       text: "3",
      //       data: null,
      //     },
      //     {
      //       id: 4,
      //       text: "4",
      //       data: null,
      //     },
      //   ],
      // },
      reAPMBrandOptions: [],
      // reAPMBrandOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกBrand",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/ProductBrand/Select2ProductBrand",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         productTypeId: 6,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลร้านค้า";
      //     },
      //   },
      // },
      rePMShopTypeId: [],
      rePMShopTypeIdOptions: [],
      rePMMachineProductCode: [],
      rePMMachineProductCodeOptions: [],
      rePMProvinceId: null,
      rePMAmpherId: null,
      rePMProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      rePMAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.rePMProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    showDate(date) {
      this.date = date;
    },
    formReset: function(e) {
      let self = this;
      self.reAPMAgentCode = [];
      self.reAPMRegion = [];
      (self.reAPMDateStart = null),
      (self.reAPMDateEnd = null),
      (self.reAPMAlertCount = []);
      self.reAPMal = [];
      self.reAPMCreatedUserId = [];
      self.reAPMBarcodeNo = null;
      self.rePMMachineProductCode = [];
      self.reAPMStatus = null;
      self.reAPMBrand = [];
      self.NFCCode = [];
      self.reAPMAlertCycle = [];
      self.reAPMShopId = [];
      self.reAPMType = [];
      self.rePMShopTypeId = [];
      (self.rePMProvinceId = null);
      (self.rePMAmpherId = null);

      self.pmrSubAgentCodes = [];
      self.pmrSubAgentCodeOptions = [];

      $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");

      $("#reAPMAgentCode")
        .val("")
        .trigger("change");

      $("#reAPMRegion")
        .val("")
        .trigger("change");

      $("#reAPMAlertCount")
        .val("")
        .trigger("change");

      $("#reAPMAlertCycle")
        .val("")
        .trigger("change");

      $("#reAPMCreatedUserId")
        .val("")
        .trigger("change");

      $("#reAPMShopId")
        .val("")
        .trigger("change");

      $("#reAPMStatus")
        .val("")
        .trigger("change");

      $("#reAPMStatus")
        .val("")
        .trigger("change");

      $("#reAPMBrand")
        .val("")
        .trigger("change");
      
      $("#rePMProvinceId")
        .val("")
        .trigger("change");

      $("#rePMAmpherId")
        .val("")
        .trigger("change");

      $("#reAPMDateStart")
        .val("")
        .trigger("change");

      $("#reAPMDateEnd")
        .val("")
        .trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    exportAlertPM: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportAlertPM",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAPMAgentCode,
          SubAgentCode: self.pmrSubAgentCodes,
          Department: self.reAPMRegion,
          MonthStart:
            self.reAPMDateStart != null
              ? self.reAPMDateStart.format("MM/YYYY")
              : null,
          MonthEnd:
            self.reAPMDateEnd != null
              ? self.reAPMDateEnd.format("MM/YYYY")
              : null,
          AlertCount: self.reAPMAlertCount,
          AlertCycle: self.reAPMAlertCycle,
          CreatedUserId: self.reAPMCreatedUserId,
          ShopId: self.reAPMShopId,
          BarcodeNo: self.reAPMBarcodeNo ? self.reAPMBarcodeNo.split(",").map(s => s.trim()) : [],
          InActiveStatus: self.reAPMStatus,
          ProductBrandId: self.reAPMBrand,
          Type: self.reAPMType,
          IsInitial: self.reAaIsInitial,
          ShopTypeId: self.rePMShopTypeId,
          ProvinceId: self.rePMProvinceId,
          AmpherId: self.rePMAmpherId,
          MachineProductCode: self.rePMMachineProductCode,
          PMType : self.shmShopPMType
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#alertPMTable").DataTable();
      table.draw();
    },
    LoadreAPMShopIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reAPMShopIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Report/AlertPM/ShopOptions", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reAPMShopIdOptions = [];
              data.forEach((element) => {
                self.reAPMShopIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reAPMShopIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreAPMCreatedUserIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        var self = this;
        axios
          .get("/Api/Report/AlertPM/UserOptions", {
            params: {
              page: 1,
              all: true,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
    reLoadreAPMCreatedUserIdOptions: function(){
      this.$refs.reAPMCreatedUserId.trigger.searchQuery = null;
    },
    // LoadreAPMBarcodeOptions({ action, searchQuery, callback }) {
    //   var self = this;
    //   self.reAPMBarcodeOptions = [];
    //   if (action === ASYNC_SEARCH) {
    //     axios
    //       .get("/Api/Report/AlertPM/Select2Barcode", {
    //         params: {
    //           page: 1,
    //           all: true,
    //           search: searchQuery,
    //         },
    //       })
    //       .then(function(response) {
    //         if (response.status == 200) {
    //           var data = response.data.results;
    //           self.reAPMBarcodeOptions = [];
    //           data.forEach((element) => {
    //             self.reAPMBarcodeOptions.push({
    //               id: element.id,
    //               label: element.text,
    //             });
    //           });
    //         }
    //         callback(null, self.reAPMBarcodeOptions);
    //       })
    //       .catch(function(error) {});
    //   }
    // },
    LoadreAPMAgentCodeOptions: function(e) {
      var self = this;
      self.reAPMAgentCodeOptions = [{ id : "", label : "Loading...", isDisabled: true}]; // เพื่อไม่ให้ใส่ว่าไม่มีข้อมูลระหว่างโหลด
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: self.reAPMRegion,
            AgentCodes: [],
            page: 1,
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            self.reAPMAgentCodeOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.reAPMAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAPMRegionOptions: function(e) {
      var self = this;
      // axios
      //   .get("/Api/Agents/Select2SearchDepartment", {
      //     params: {
      //       page: 1,
      //       all: true,
      //     },
      //   })
      //   .then(function(response) {
      //     if (response.status == 200) {
      //       var data = response.data.results;
      //       data.forEach((element) => {
      //         self.reAPMRegionOptions.push({
      //           id: element.id,
      //           label: element.text,
      //         });
      //       });
      //     }
      //   })
      //   .catch(function(error) {});
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAPMRegionOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAPMBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2ProductBrand", {
          params: {
            page: 1,
            productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAPMBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAPMAlertCountOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/AlertPM/AlertCountOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAPMAlertCountOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    // ปิดไว้จากเคส https://bt.sbpds.co.th/view.php?id=3084 พี่นัท PM บอกว่า สร้างเป็นแบ static เลยดีกว่า
    // LoadreAPMAlertCycleOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Report/AlertPM/AlertCycleOptions", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.reAPMAlertCycleOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    LoadShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMMachineProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            productTypeId: 3,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMMachineProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    onAmpherIdChange: function() {
      $("#rePMAmpherId")
        .val("")
        .trigger("change");
    }, 
    AgentClearAfterselect: function(){  
      let self = this; 
      self.pmrSubAgentCodes = []; 
  
      $("#pmrSubAgentCodes").val("").trigger("change"); 
      $(`[class="vue-treeselect__input"]`).val("");
    },
  },
  async mounted() {
    let self = this;

    // self.LoadreAPMCreatedUserIdOptions();
    self.LoadreAPMAgentCodeOptions();
    self.LoadreAPMRegionOptions();
    self.LoadreAPMBrandOptions();
    self.LoadreAPMAlertCountOptions();
    // self.LoadreAPMAlertCycleOptions();
    self.LoadShopTypeIdOptions();
    self.LoadrePMMachineProductCodeOptions();
    self.LoadshmShopPMTypeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
    $("#reAPMStatus").val(false + "").trigger("change");

    $(self.$refs.reAPMDateStart).datepicker({
      format: "mm/yyyy",
      viewMode: "months",
      minViewMode: "months",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.reAPMDateStart)
      .datepicker(
        "update",
        !!self.reAPMDateStart ? self.reAPMDateStart.format("MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reAPMDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reAPMDateEnd).datepicker({
      format: "mm/yyyy",
      viewMode: "months",
      minViewMode: "months",
      autoclose: true,
      clearBtn: true,
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.reAPMDateEnd)
      .datepicker(
        "update",
        !!self.reAPMDateEnd ? self.reAPMDateEnd.format("MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reAPMDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#alertPMTable");
    table.DataTable({
      autoWidth: true,
      scrollY: "100%",
      scrollX: true,
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/Report/AlertPM",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          let jsonSearch = {
            AgentCode: self.reAPMAgentCode,
            SubAgentCode: self.pmrSubAgentCodes,
            Department: self.reAPMRegion,
            MonthStart:
              self.reAPMDateStart != null
                ? self.reAPMDateStart.format("MM/YYYY")
                : null,
            MonthEnd:
              self.reAPMDateEnd != null
                ? self.reAPMDateEnd.format("MM/YYYY")
                : null,
            AlertCount: self.reAPMAlertCount,
            AlertCycle: self.reAPMAlertCycle,
            CreatedUserId: self.reAPMCreatedUserId,
            ShopId: self.reAPMShopId,
            BarcodeNo: self.reAPMBarcodeNo ? self.reAPMBarcodeNo.split(",").map(s => s.trim()) : [],
            InActiveStatus: self.reAPMStatus,
            ProductBrandId: self.reAPMBrand,
            Type: self.reAPMType,
            IsInitial: self.reAaIsInitial,
            ShopTypeId: self.rePMShopTypeId,
            ProvinceId: self.rePMProvinceId,
            AmpherId: self.rePMAmpherId,
            MachineProductCode: self.rePMMachineProductCode,
            PMType : self.shmShopPMType
          };
          return JSON.stringify($.extend(d, jsonSearch));
        },
      },
      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [30, 50, 100],

      pageLength: 30,

      language: {
        lengthMenu: "Display _MENU_",
      },
      // Order settings
      order: [[13, "desc"]],
      columns: [
        { data: "agentCode", className: "text-center" },
        { data: "agentName", className: "text-center" },
        { data: "agentTypeName", className: "text-center" },
        { data: "department", className: "text-center" },
        { data: "createdUser", className: "text-center" },
        { data: "shopCode", className: "text-center" },
        { data: "name1", className: "text-center" },
        { data: "name2", className: "text-center" },
        { data: "shopPMTypeName", className: "text-center" },
        { data: "type", className: "text-center" },
        //{ data: "barcodeNo", className: "text-center" },
        { data: "barcodeNoOld", className: "text-center" },
        { data: "machineProductName", className: "text-center" },
        { data: "productBrandName", className: "text-center" },
        {
          data: "lastDate",
          className: "text-center",
          render: function(data, type, full, meta) {
            return full.lastDateString;
          },
        },
        {
          data: "alertDate",
          className: "text-center",
          render: function(data, type, full, meta) {
            return full.alertDateString;
          },
        },
        { data: "alertConfigDay", className: "text-center" },
        { data: "round", className: "text-center" },
        // {
        //   data: "mappingStatus",
        //   className: "text-center",
        //   render: function(data, type, full, meta) {
        //     if (data) return "จับคู่";
        //     else return "ยกเลิกจับคู่";
        //   },
        // },
        // { data: "shopTypeName", className: "text-center" },
        // { data: "provinceName", className: "text-center" },
        // { data: "ampherName", className: "text-center" },

      ],
      drawCallback: function(settings) {
        self.reAaIsInitial = false;
        self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
      },
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });
  },
};
</script>

<style lang="scss" scoped>
  .form-group{
    margin-bottom: 0.6rem;
  }
  label {
    margin-bottom: 0.1rem;
  }
</style>



// WEBPACK FOOTER //
// App/Components/AdminReport/AlertPM.vue